import { useMemo } from "react"

import { Client } from "./client"
import { Parameters, ResourceObject } from "commons/types"

const useClient = (token?: string) => {
  const client = useMemo(() => new Client(token), [token])

  const read = <T>(endpoint: string) => client.read<T>(endpoint)

  const post = <T, R>(endpoint: string, resource: T, headers?: HeadersInit) =>
    client.post<T, R>(endpoint, resource, headers)

  const update = <T, R>(endpoint: string, resource: T, headers?: HeadersInit) =>
    client.update<T, R>(endpoint, resource, headers)

  const put = <T, R>(endpoint: string, resource: T, headers?: HeadersInit) =>
    client.put<T, R>(endpoint, resource, headers)

  const operationRequest = <T extends ResourceObject>({
    endpoint,
    method,
    operation,
    id,
    parameters,
    filters,
    signal,
    headers,
  }: OperationRequestArgs) =>
    client.operationRequest<T>(
      endpoint,
      method,
      id,
      parameters,
      filters,
      operation,
      method === "GET" ? signal : undefined,
      headers,
    )

  return { read, post, update, put, operationRequest }
}

interface OperationRequestArgs {
  endpoint: string
  method: "GET" | "POST" | "PUT" | "PATCH"
  operation: string
  id?: string
  parameters?: Parameters
  filters?: URLSearchParams
  signal?: AbortSignal
  headers?: HeadersInit
}

export { useClient }
